import { createPortal } from "react-dom";
import { BodyshopCopy } from "@/components/BodyshopCopy";

const Cut = () => (
  <div className="w-0 border-l-2 border-dashed border-neutral-400 relative">
    <span className="absolute top-1/2 -left-[5px] -translate-y-1/2 text-[9px] text-neutral-400 [writing-mode:vertical-rl]">✂ taglia qui</span>
  </div>
);

export const printBatch = () => {
  const st = document.createElement("style");
  st.textContent = "@media print { @page { size: A4 landscape; margin: 0; } }";
  document.head.appendChild(st);
  document.body.classList.add("print-batch");
  const done = () => { document.body.classList.remove("print-batch"); st.remove(); window.removeEventListener("afterprint", done); };
  window.addEventListener("afterprint", done);
  setTimeout(() => window.print(), 250);
};

// Vehicle copies, two per A4 landscape sheet; rendered into <body> and only visible when printing
export const VehicleCopiesBatch = ({ jobs }) => {
  const pages = [];
  for (let i = 0; i < jobs.length; i += 2) pages.push(jobs.slice(i, i + 2));
  return createPortal(
    <div id="bodyshop-batch" className="hidden bg-white text-black" data-testid="bodyshop-batch">
      {pages.map((p, i) => (
        <div key={i} className="batch-page flex" data-testid={`bodyshop-batch-page-${i + 1}`}>
          <BodyshopCopy f={p[0]} />
          <Cut />
          {p[1] ? <BodyshopCopy f={p[1]} /> : <div className="w-1/2" />}
        </div>
      ))}
    </div>,
    document.body,
  );
};
